module.exports = __webpack_public_path__ + "img/walletBack.ed287ed8.png";